import React, { useState, useEffect } from 'react';
import {
  AdminContentContainer,
  AdminContentTitle,
  GrantButton,
  AdminsList,
  AdminItem,
  AdminListTitle,
  RevokeButton,
  NoResults,
  ScrollContainer,
} from '../styles';
import { adminUpdateUserRole } from '../api';
import { Spinner } from '.';

const AdminManager = ({ allUsers }) => {
  const [loading, setLoading] = useState(true);

  const updateUserRole = async (user, role) => {
    try {
      
      const response = await adminUpdateUserRole(user.username, role);

      const data = await response.json();

      if (response.ok) {
        window.location.reload();
      } else {
        console.error('Erro ao atualizar role do usuário:', data);
      }

    } catch (error) {
      console.error('Erro na requisição PUT:', error);
    }
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  const renderUserList = (
    users,
    role,
    isAdminList = false,
    isWorker = false
  ) => {
    const sortedUsers = [...users].sort((a, b) => a.nome.localeCompare(b.nome));

    return (
      <ScrollContainer>
        <ul style={{ padding: '0', margin: 0 }}>
          {sortedUsers.length > 0 ? (
            sortedUsers.map((user) => (
              <AdminItem key={user.username}>
                <span>
                  {user.nome} ({user.username})
                </span>
                {isAdminList || isWorker ? (
                  <RevokeButton onClick={() => updateUserRole(user, 2)}>
                    Remover Acesso
                  </RevokeButton>
                ) : (
                  <GrantButton onClick={() => updateUserRole(user, 4)}>
                    Conceder Acesso
                  </GrantButton>
                )}
              </AdminItem>
            ))
          ) : (
            <NoResults>Nenhum {role} encontrado</NoResults>
          )}
        </ul>
      </ScrollContainer>
    );
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <AdminContentContainer>
      <AdminContentTitle>Gerenciamento de Acessos Administrador</AdminContentTitle>

      <AdminsList>
        <AdminListTitle>Trabalhadores</AdminListTitle>
        {renderUserList(allUsers.worker.users, 'trabalhador', false, true)}
      </AdminsList>

      <AdminsList>
        <AdminListTitle>Usuários Comuns</AdminListTitle>
        {renderUserList(allUsers.user.users, 'usuário')}
      </AdminsList>

      <AdminsList>
        <AdminListTitle>Usuários com Acesso de Administrador</AdminListTitle>
        {renderUserList(allUsers.admin.users, 'admin', true)}
      </AdminsList>
    </AdminContentContainer>
  );
};

export default AdminManager;
